var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useFormik } from 'formik';
import { Grid } from '@mui/material';
import { camelize } from '../../../utils/camelize';
import PageSubmitButton from '../../molecules/PageSubmitButton';
import { FormikTextField } from '../../atoms/TextField';
import { useNotify } from '../../../hooks/notificationHook';
import { DeliveryRequestFieldFormats } from '../../../constants/fieldFormats';
import DeliveryRequestConfirmationDialog from './DeliveryRequestConfirmationDialog';
import DeliveryRequestsAddressForm from './DeliveryRequestsAddressForm';
import DeliveryRequestItemsAndRequestDateForm from '../../Order/DeliveryRequestItemsAndRequestDateForm';
var REQUIRED_FIELDS = [
    'person_name',
    'postal_code',
    'prefecture',
    'city',
    'address',
    'phone',
    'country_calling_code',
];
var EUROPE_REQUIRED_FIELDS = REQUIRED_FIELDS.concat([
    'vat_number',
]);
var GridContainer = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiGrid-container {\n    width: 100%;\n    margin: 20px 0px;\n  }\n"], ["\n  &.MuiGrid-container {\n    width: 100%;\n    margin: 20px 0px;\n  }\n"])));
var DeliveryRequestsForm = function (_a) {
    var roaster = _a.roaster, deliveryRequests = _a.deliveryRequests, _b = _a.deliveryRequestGroupItemsAndRequestDates, deliveryRequestGroupItemsAndRequestDates = _b === void 0 ? [] : _b, warehouseItems = _a.warehouseItems, onRequest = _a.onRequest, deliveryRequestFormType = _a.deliveryRequestFormType, onChangeDeliveryRequestFormType = _a.onChangeDeliveryRequestFormType, initialFormValues = _a.initialFormValues, onSuccess = _a.onSuccess, isNew = _a.isNew, isAdmin = _a.isAdmin;
    var t = useTranslation().t;
    var notify = useNotify();
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var _d = React.useState(false), dialogOpen = _d[0], setDialogOpen = _d[1];
    var _e = React.useState(isNew
        ? buildDeliveryRequestGroupFromWarehouseItems(warehouseItems)
        : buildDeliveryRequestGroupFromDeliveryRequests(deliveryRequests, deliveryRequestGroupItemsAndRequestDates)), deliveryRequestGroup = _e[0], setDeliveryRequestGroup = _e[1];
    var maxInstallmentDeliveryRequestItemsAndRequestDatesLength = React.useMemo(function () {
        if (isAdmin)
            return 100;
        var shippedOrDeliveredDeliveryRequestCounts = warehouseItems === null || warehouseItems === void 0 ? void 0 : warehouseItems.map(function (_a) {
            var deliveryRequestItems = _a.deliveryRequestItems;
            return deliveryRequestItems
                .map(function (_a) {
                var deliveryRequest = _a.deliveryRequest;
                return deliveryRequest;
            })
                .filter(function (_a) {
                var status = _a.status;
                return !['canceled', 'requested'].includes(status);
            })
                .length;
        });
        if (!shippedOrDeliveredDeliveryRequestCounts)
            return 3;
        return Math.max(1, 3 - Math.max.apply(Math, shippedOrDeliveredDeliveryRequestCounts));
    }, [warehouseItems, isAdmin]);
    var requestItemsWithRequestableQuantity = React.useMemo(function () {
        if (!warehouseItems)
            return [];
        return warehouseItems.map(function (_a) {
            var id = _a.id, total = _a.total, remainingQuantity = _a.remainingQuantity, requestableQuantity = _a.requestableQuantity, _b = _a.offer, lotNumber = _b.lotNumber, bagSize = _b.bagSize;
            var deliveryRequestsQuantity = deliveryRequests
                .map(function (_a) {
                var items = _a.items;
                return items;
            })
                .flat()
                .filter(function (_a) {
                var warehouseItem = _a.warehouseItem;
                return warehouseItem.id === id;
            })
                .reduce(function (accumulator, _a) {
                var quantity = _a.quantity;
                return accumulator + quantity;
            }, 0);
            var requestedItemsQuantity = deliveryRequestGroup.itemsAndRequestDates
                .filter(function (_a) {
                var key = _a.key;
                return deliveryRequestFormType === 'oneTime'
                    ? key === 'oneTime'
                    : key !== 'oneTime';
            })
                .map(function (_a) {
                var itemsAttributes = _a.itemsAttributes;
                return itemsAttributes.filter(function (_a) {
                    var warehouseItemId = _a.warehouseItemId;
                    return warehouseItemId === id;
                });
            })
                .flat()
                .reduce(function (accumulator, _a) {
                var quantity = _a.quantity;
                return accumulator + quantity;
            }, 0);
            return {
                warehouseItemId: id,
                quantity: total,
                lotNumber: lotNumber,
                roasterTransportToWarehousesStatus: 'warehousing',
                remainingQuantity: remainingQuantity,
                bagSize: bagSize,
                requestableQuantity: deliveryRequestsQuantity -
                    requestedItemsQuantity +
                    requestableQuantity,
            };
        });
    }, [
        warehouseItems,
        deliveryRequestFormType,
        deliveryRequestGroup,
        deliveryRequests,
    ]);
    var onSubmit = React.useCallback(function () {
        setDialogOpen(true);
    }, []);
    var onComplete = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var itemsAndRequestDates, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    itemsAndRequestDates = deliveryRequestGroup.itemsAndRequestDates.filter(function (item) {
                        return deliveryRequestFormType === 'oneTime'
                            ? item.key === 'oneTime'
                            : item.key !== 'oneTime';
                    });
                    return [4 /*yield*/, onRequest(values, __assign(__assign({}, deliveryRequestGroup), { itemsAndRequestDates: itemsAndRequestDates }))];
                case 1:
                    response = _a.sent();
                    if (!response) {
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    onSuccess(response);
                    notify('success', [t('messages.deliveryRequestSuccess')]);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [
        deliveryRequestGroup,
        onRequest,
        setLoading,
        notify,
        t,
        onSuccess,
        deliveryRequestFormType,
    ]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        (roaster.isOfficeEurope
            ? EUROPE_REQUIRED_FIELDS
            : REQUIRED_FIELDS).forEach(function (field) {
            if (!values[field] || values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.deliveryRequest.".concat(camelize(field))),
                });
            }
        });
        Object.entries(DeliveryRequestFieldFormats).forEach(function (_a) {
            var field = _a[0], regExp = _a[1];
            var fieldAsKey = field;
            var value = values[fieldAsKey];
            if (value && !regExp.test(value)) {
                errors[fieldAsKey] = t('errors.invalid', {
                    field: t("params.deliveryRequest.".concat(camelize(field))),
                });
            }
        });
        return errors;
    }, [t, roaster.isOfficeEurope]);
    var formik = useFormik({
        initialValues: initialFormValues,
        onSubmit: onSubmit,
        validateOnMount: true,
        validateOnChange: true,
        validateOnBlur: true,
        validate: validate,
        enableReinitialize: true,
    });
    var changeAddress = React.useCallback(function (address) {
        formik.setValues(__assign(__assign({}, formik.values), { store_name: address.storeName, person_name: address.personName, name_kana: address.nameKana, country_calling_code: address.countryCallingCode, phone: address.phone, postal_code: address.postalCode, prefecture: address.prefecture, city: address.city, address: address.address, building: address.building }));
    }, [formik]);
    var handleAddDeliveryRequestItemsAndRequestDate = React.useCallback(function (deliveryRequestGroupItemsAndRequestDate) {
        var newItemsAndRequestDates = deliveryRequestGroup.itemsAndRequestDates.concat([
            deliveryRequestGroupItemsAndRequestDate,
        ]);
        setDeliveryRequestGroup(__assign(__assign({}, deliveryRequestGroup), { itemsAndRequestDates: newItemsAndRequestDates }));
    }, [deliveryRequestGroup, setDeliveryRequestGroup]);
    var handleUpdateDeliveryRequestItemsAndRequestDate = React.useCallback(function (deliveryRequestGroupItemsAndRequestDate) {
        var newItemsAndRequestDates = [];
        deliveryRequestGroup.itemsAndRequestDates.forEach(function (itemAndRequestDate) {
            var newItemAndRequestDate = itemAndRequestDate.key ===
                deliveryRequestGroupItemsAndRequestDate.key
                ? deliveryRequestGroupItemsAndRequestDate
                : itemAndRequestDate;
            newItemsAndRequestDates.push(newItemAndRequestDate);
        });
        setDeliveryRequestGroup(__assign(__assign({}, deliveryRequestGroup), { itemsAndRequestDates: newItemsAndRequestDates }));
    }, [deliveryRequestGroup, setDeliveryRequestGroup]);
    var handleDeleteDeliveryRequestItemsAndRequestDate = React.useCallback(function (deliveryRequestGroupItemsAndRequestDate) {
        var newItemsAndRequestDates = deliveryRequestGroup.itemsAndRequestDates.filter(function (itemsAndRequestDate) {
            return (itemsAndRequestDate.key !==
                deliveryRequestGroupItemsAndRequestDate.key);
        });
        setDeliveryRequestGroup(__assign(__assign({}, deliveryRequestGroup), { itemsAndRequestDates: newItemsAndRequestDates }));
    }, [deliveryRequestGroup, setDeliveryRequestGroup]);
    var deliveryRequestGroupIsValid = React.useMemo(function () {
        if (!requestItemsWithRequestableQuantity)
            return false;
        var allItemRequested = requestItemsWithRequestableQuantity.every(function (_a) {
            var requestableQuantity = _a.requestableQuantity;
            return requestableQuantity === 0;
        });
        if (!allItemRequested)
            return false;
        var itemsAndRequestDates = deliveryRequestGroup.itemsAndRequestDates.filter(function (item) {
            return deliveryRequestFormType === 'oneTime'
                ? item.key === 'oneTime'
                : item.key !== 'oneTime';
        });
        return itemsAndRequestDates.every(function (itemAndRequestDate) {
            return ((itemAndRequestDate.isFastestDelivery &&
                itemAndRequestDate.requestDate === null) ||
                (!itemAndRequestDate.isFastestDelivery &&
                    itemAndRequestDate.requestDate !== null));
        });
    }, [
        requestItemsWithRequestableQuantity,
        deliveryRequestFormType,
        deliveryRequestGroup,
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { onSubmit: formik.handleSubmit },
            React.createElement(GridContainer, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(DeliveryRequestsAddressForm, { roaster: roaster, address: deliveryRequestGroup.address, onChangeAddress: changeAddress, isAdmin: isAdmin })),
                React.createElement(Grid, { item: true, xs: 12, sx: { mb: 2 } },
                    React.createElement(DeliveryRequestItemsAndRequestDateForm, { roaster: roaster, deliveryRequestFormType: deliveryRequestFormType, deliveryRequestItemsAndRequestDates: deliveryRequestGroup.itemsAndRequestDates, requestItemsWithRequestableQuantity: requestItemsWithRequestableQuantity, maxInstallmentDeliveryRequestItemsAndRequestDatesLength: maxInstallmentDeliveryRequestItemsAndRequestDatesLength, onChangeDeliveryRequestFormType: onChangeDeliveryRequestFormType, addDeliveryRequestItemsAndRequestDate: handleAddDeliveryRequestItemsAndRequestDate, updateDeliveryRequestItemsAndRequestDate: handleUpdateDeliveryRequestItemsAndRequestDate, deleteDeliveryRequestItemsAndRequestDate: handleDeleteDeliveryRequestItemsAndRequestDate, isAdmin: isAdmin })),
                roaster.isOfficeEurope && (React.createElement(Grid, { item: true, xs: 12, sm: 4, sx: { mb: 1 } },
                    React.createElement(FormikTextField, { fullWidth: true, name: "vat_number", label: t('params.deliveryRequest.vatNumber'), formik: formik }))),
                roaster.country.eoriNumberEnabled && (React.createElement(Grid, { item: true, xs: 12, sm: 4, sx: { mb: 1 } },
                    React.createElement(FormikTextField, { fullWidth: true, name: "eori_number", label: t('params.eoriNumber'), formik: formik }))),
                React.createElement(Grid, { item: true, xs: 12, sx: { mb: 1 } },
                    React.createElement(FormikTextField, { multiline: true, rows: 4, fullWidth: true, name: "note", label: t('params.deliveryRequest.note'), formik: formik })),
                isNew && (React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                    React.createElement(FormikTextField, { fullWidth: true, name: "campaign_code", label: t('params.campaign.code'), formik: formik }))),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(PageSubmitButton, { disabled: !formik.isValid || !deliveryRequestGroupIsValid }, t('buttons.deliveryRequest')),
                    React.createElement(DeliveryRequestConfirmationDialog, { open: dialogOpen, onClose: function () {
                            setDialogOpen(false);
                        }, onComplete: function () { return onComplete(formik.values); }, submitDisabled: loading, isRoasterUs: roaster.country.code === 'US' }))))));
};
export default DeliveryRequestsForm;
var buildDeliveryRequestGroupFromWarehouseItems = function (warehouseItems) {
    return {
        address: null,
        itemsAndRequestDates: [
            {
                key: 'oneTime',
                requestDate: null,
                isFastestDelivery: true,
                itemsAttributes: warehouseItems.map(function (warehouseItem) { return ({
                    warehouseItemId: warehouseItem.id,
                    quantity: warehouseItem.requestableQuantity,
                    bagSize: warehouseItem.offer.bagSize,
                    lotNumber: warehouseItem.offer.lotNumber,
                }); }),
            },
        ],
    };
};
var buildDeliveryRequestGroupFromDeliveryRequests = function (deliveryRequests, deliveryRequestGroupItemsAndRequestDates) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return {
        address: {
            id: '',
            addressType: 'delivery',
            billingName: '',
            storeName: (_a = deliveryRequests[0]) === null || _a === void 0 ? void 0 : _a.storeName,
            personName: (_b = deliveryRequests[0]) === null || _b === void 0 ? void 0 : _b.personName,
            nameKana: (_c = deliveryRequests[0]) === null || _c === void 0 ? void 0 : _c.nameKana,
            phone: (_d = deliveryRequests[0]) === null || _d === void 0 ? void 0 : _d.phone,
            countryCallingCode: (_e = deliveryRequests[0]) === null || _e === void 0 ? void 0 : _e.countryCallingCode,
            countryCode: (_f = deliveryRequests[0]) === null || _f === void 0 ? void 0 : _f.countryCallingCode,
            email: '',
            postalCode: (_g = deliveryRequests[0]) === null || _g === void 0 ? void 0 : _g.postalCode,
            prefecture: (_h = deliveryRequests[0]) === null || _h === void 0 ? void 0 : _h.prefecture,
            city: (_j = deliveryRequests[0]) === null || _j === void 0 ? void 0 : _j.city,
            address: (_k = deliveryRequests[0]) === null || _k === void 0 ? void 0 : _k.address,
            building: (_l = deliveryRequests[0]) === null || _l === void 0 ? void 0 : _l.building,
            isDefault: false,
            editable: false,
        },
        itemsAndRequestDates: deliveryRequestGroupItemsAndRequestDates,
    };
};
var templateObject_1;
